import { render, staticRenderFns } from "./special-item.vue?vue&type=template&id=4e504cf5"
import script from "./special-item.vue?vue&type=script&lang=js"
export * from "./special-item.vue?vue&type=script&lang=js"
import style0 from "./special-item.vue?vue&type=style&index=0&id=4e504cf5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports